// extracted by mini-css-extract-plugin
export var link = "_ui-0";